import {Inject, Pipe, PipeTransform} from '@angular/core';
import { Locale } from '@dash/randy/shared/classes/Locale';
import { GlobalDataStorageService } from '../service/global-data-storage.service';
import { COLLECTION_LOCALE } from '@dash/randy/tokens/collection-item-locale.token';

@Pipe({
    name: 'locale',
    standalone: false
})
export class LocalePipe implements PipeTransform {
  constructor(
    @Inject(COLLECTION_LOCALE) public collectionLocaleId: string,
  ) {}

  transform(value: Locale[], lang?: string): string {
    if (!value) {
      return $localize`Wachten op vertaling...`;
    }
    if (value.length === 0) {
      console.error(value, 'This value doenst have any records!');
      return 'No text found';
    }
    if (!lang) {
      lang = this.collectionLocaleId;
    }
    let localeObj = value.find(locale => locale.locale === lang);
    if (localeObj) {
      return localeObj.data;
    }
    console.debug(value, 'Locale "' + lang + '" isn\'t found!');
    return value[0].data;
  }
}
